import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface UseGetTaskByIdProps {
  projectId: string;
  planId: string;
  taskId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTaskById = async (taskId: string, planId: string, projectId: string) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/plans/${planId}/tasks/${taskId}`);

const useGetTaskById = ({
  taskId,
  planId,
  projectId,
  queryParams,
}: UseGetTaskByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["task", taskId],
    queryFn: () => getTaskById(taskId, planId, projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetTaskById;
